/* eslint-disable import/prefer-default-export */

export function allIds() {
  return [];
}

export function byId() {
  return {};
}
